import { useMutation } from "@tanstack/react-query"
import { useContext } from "react"
import { toast } from "sonner"
import { changePasswordApi } from "../services/auth.api"
import AuthContext from "../../../app/Context/AuthContext"

export const useChangePasswordMutation=()=>{
    const {handleError}=useContext(AuthContext)
    return useMutation({
        mutationFn:async(data)=>{
         return await changePasswordApi(data)
        },
         retry:false,
        onError:(error)=>handleError(error),
         onSuccess:()=>{
     toast.success("Your Password Changed successfully ")
        }
    })
}